import React, { useState, useRef, useEffect } from 'react';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { Spinner } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import useSWR from 'swr';

import axios from '../../admin-axios';
import { detectError } from '../../utils';
import LongPaginationHandler from '../LongPaginationHandler';
import classes from './index.module.scss';

const fetcher = (url) => axios.get(url).then((res) => res.data);

const DSRTable = () => {
  // eslint-disable-next-line no-unused-vars
  // const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const tableRef = useRef(null);
  const {
    user: { stationId }
  } = useSelector((state) => state.auth);
  const {
    data,
    error,
    isLoading: loading,
    mutate
  } = useSWR(`/transaction/daily/sales/all/${stationId}?page=${page}`, fetcher);

  if (error) {
    toast.error(detectError(error));
  }

  const paginate = (pageNumber) => {
    setPage(pageNumber);
    mutate();
  };

  useEffect(() => {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className={classes.dsrtable}>
      <div className="row mb-5">
        <div className="col-10">
          <div className={`${classes.dsrtable_search}`}>
            <input
              type="text"
              // ref={searchRef}
              // onKeyDown={searchHandler}
              className={`form-control p-3 ${classes.dsrtable_search_input}`}
              placeholder="Search by Customer name, Phone number"
              aria-label="search"
            />
          </div>
        </div>
        <div className="col-2">
          <DownloadTableExcel
            filename={`dsr_${new Date().toLocaleDateString()}`}
            sheet="daily_sales_report"
            currentTableRef={tableRef.current}>
            <button className={`${classes.dsrtable_download_button} w-100 h-100 btn`} type="button">
              {' '}
              Download{' '}
            </button>
          </DownloadTableExcel>
        </div>
      </div>
      <div className={classes.dsrtable_table_wrapper}>
        <table ref={tableRef} className={`table table-striped ${classes.dsrtable_table}`}>
          <thead>
            <tr>
              <th scope="col">Transaction ID</th>
              <th scope="col">Customer Type</th>
              <th scope="col">Customer Name</th>
              <th scope="col">Phone No.</th>
              <th scope="col">Gas Quantity Purchased</th>
              <th scope="col">Price/Kg</th>
              <th scope="col">Amount</th>
              <th scope="col">Status</th>
              <th scope="col">Price Approval</th>
            </tr>
          </thead>
          <tbody>
            {loading && (
              <tr className="py-3">
                <td colSpan={9}>
                  <div className="d-flex justify-content-center w-100">
                    <Spinner className="spinner" animation="border" variant="dark" />
                  </div>
                </td>
              </tr>
            )}
            {!loading &&
              data &&
              data?.daily_sales_history &&
              data?.daily_sales_history.data.length > 0 &&
              data?.daily_sales_history.data.map((tx) => (
                <tr key={tx.transaction_id}>
                  <td>{tx.transaction_id}</td>
                  <td>
                    {tx.firstname} {tx.lastname}
                  </td>
                  <td>{tx.customer_type}</td>
                  <td>{tx.phone}</td>
                  <td>{tx.gas_quantity}</td>
                  <td>{tx.gas_price}</td>
                  <td>{tx.amount}</td>
                  <td style={{ color: tx.status === 'Cleared' ? 'green' : 'red' }}>{tx.status}</td>
                  <td>Standard</td>
                </tr>
              ))}

            {!loading &&
              data &&
              data?.daily_sales_history &&
              data?.daily_sales_history.data.length === 0 && (
                <tr>
                  <td colSpan={9} className="w-100 text-center">
                    No Recent History
                  </td>
                </tr>
              )}

            {!loading && data && data?.message && (
              <tr>
                <td colSpan={9} className="w-100 text-center">
                  {data.message}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {data && data?.daily_sales_history && (
        <LongPaginationHandler
          elementsPerPage={data?.daily_sales_history.per_page}
          totalElements={data?.daily_sales_history.total}
          activePage={page}
          paginate={paginate}
        />
      )}
    </div>
  );
};

export default DSRTable;
